module.exports = __webpack_public_path__ + "static/assets/b1042e3dc7977193ae4dffa54728a84b.png";